const o = {
  extend_desc: '',
  extend_reason: '',
  extend_rule: '',
  supple_data: '[]',
};
export default o;
